export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: {
    className?: string
    text?: string
    html?: string
    attrs?: Record<string, string | number | boolean | undefined | null>
    on?: Partial<{
      [E in keyof HTMLElementEventMap as E]: (ev: HTMLElementEventMap[E]) => void
    }>
  } = {},
  children: (Node | string | null | undefined | false)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag)
  if (props.className) node.className = props.className
  if (props.text != null) node.textContent = props.text
  if (props.html != null) node.innerHTML = props.html
  if (props.attrs) {
    for (const [key, value] of Object.entries(props.attrs)) {
      if (value == null || value === false) continue
      if (value === true) node.setAttribute(key, '')
      else node.setAttribute(key, String(value))
    }
  }
  if (props.on) {
    for (const [event, handler] of Object.entries(props.on)) {
      if (handler) node.addEventListener(event, handler as EventListener)
    }
  }
  for (const child of children) {
    if (child == null || child === false) continue
    node.append(typeof child === 'string' ? document.createTextNode(child) : child)
  }
  return node
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild)
}
